import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { Project } from '@portal-core/projects/models/project.model';
import { ProjectsService } from '@portal-core/projects/services/projects.service';
import { ProjectPageFilterConfig } from '@portal-core/projects/util/project-page-filter-config';
import { ListControl } from '@portal-core/ui/list/util/list-control';
import { ListBase } from '@portal-core/ui/list/util/list.base';
import { of } from 'rxjs';
import { ListComponent } from '@portal-core/ui/list/components/list/list.component';
import { ListItemDirective } from '@portal-core/ui/list/directives/list-item/list-item.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { MatListItem } from '@angular/material/list';
import { ProjectAvatarComponent } from '@portal-core/projects/components/project-avatar/project-avatar.component';
import { NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { EmptyListDirective } from '@portal-core/ui/list/directives/empty-list/empty-list.directive';
import { AllItemsLoadedListDirective } from '@portal-core/ui/list/directives/all-items-loaded-list/all-items-loaded-list.directive';
import { IncludedInPipe } from '@portal-core/general/pipes/included-in/included-in.pipe';

@Component({
    selector: 'mc-license-user-projects-list',
    templateUrl: './license-user-projects-list.component.html',
    styleUrls: ['./license-user-projects-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ListComponent, ListItemDirective, MatTooltip, MatListItem, ProjectAvatarComponent, NgIf, MatIconButton, MatIcon, EmptyListDirective, AllItemsLoadedListDirective, IncludedInPipe]
})
export class LicenseUserProjectsListComponent extends ListBase<Project> implements OnChanges {
  readonly collectionService = inject(ProjectsService);
  private readonly licenseUsersService = inject(LicenseUsersService);
  private readonly snackBar = inject(MatSnackBar);
  @Input() licenseUserId: number;
  @Input() canEdit: boolean = false;

  @Output() saved: EventEmitter<void> = new EventEmitter<void>();

  removing: number[] = [];

  override filterConfig: ProjectPageFilterConfig = new ProjectPageFilterConfig(['Name', 'Initials']);

  listControl: ListControl<Project> = new ListControl<Project>(this.collectionService, filter => {
    if (typeof this.licenseUserId === 'number') {
      return this.licenseUsersService.getProjects$(this.licenseUserId, filter);
    } else {
      return of(null);
    }
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseUserId) {
      this.hardReload();
    }
  }

  onRemoveProject(projectId: number) {
    this.removing = [
      ...this.removing,
      projectId
    ];
    this.collectionService.deleteProjectLicenseUser$(projectId, this.licenseUserId).subscribe(() => {
      this.collectionService.removePagedDataListItems$(this.dataListId, [projectId]);
      this.removing = this.removing.filter(id => id !== projectId);
      this.saved.emit();
    }, () => {
      this.removing = this.removing.filter(id => id !== projectId);
      this.snackBar.open('Unable to remove the user from the project.', 'OK');
    });
  }
}
